class DlSocialImageSlideshowY extends HTMLElement {
  constructor() {
    super();
    this.swiper = null;
  }

  connectedCallback() {
    this.init();
  }

  init() {
    this.swiperEl = this.querySelector('.dl-social-image-slideshow-y__swiper');
    this.prevBtn = this.querySelector('.dl-social-image-slideshow-y__prev');
    this.nextBtn = this.querySelector('.dl-social-image-slideshow-y__next');
    this.modal = this.querySelector('.dl-social-image-slideshow-y__modal');
    this.modalImg = this.querySelector('.dl-social-image-slideshow-y__modal-image');

    if (!this.swiperEl) return;

    this.initSwiper();
    this.bindZoom();
    this.bindModal();
  }

  initSwiper() {
    if (typeof Swiper === 'undefined') {
      console.warn('Swiper library not loaded');
      return;
    }

    const autoplayEnabled = String(this.dataset.autoplay) === 'true';
    const autoplayDelay = Number(this.dataset.autoplayDelay || 3000);
    const slideCount = this.querySelectorAll('.dl-social-image-slideshow-y__slide').length;

    const options = {
      // 手机 ≤990：1 + 0.15 张露出下一张（与右侧贴边排版配合）
      slidesPerView: 1.15,
      spaceBetween: 19,
      speed: 600,
      loop: slideCount > 1,
      allowTouchMove: true,
      watchOverflow: true,
      centeredSlides: false,
      navigation: {
        nextEl: this.nextBtn,
        prevEl: this.prevBtn,
      },
      breakpoints: {
        991: {
          slidesPerView: 3.3,
          centeredSlides: true,
          initialSlide: 1,
        },
      },
    };

    if (autoplayEnabled) {
      options.autoplay = {
        delay: Number.isFinite(autoplayDelay) ? autoplayDelay : 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      };
    }

    this.swiper = new Swiper(this.swiperEl, options);
  }

  bindZoom() {
    const zoomButtons = this.querySelectorAll('.dl-social-image-slideshow-y__zoom-btn[data-zoomable="true"]');
    if (!zoomButtons.length) return;

    zoomButtons.forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.openImageModal(btn);
      });
    });
  }

  bindModal() {
    if (!this.modal) return;

    this.backdrop = this.querySelector('.dl-social-image-slideshow-y__modal-backdrop');
    this.closeBtn = this.querySelector('.dl-social-image-slideshow-y__modal-close');

    // Bind explicit close targets (no bubbling assumptions).
    if (this.backdrop) {
      this.backdrop.addEventListener('click', () => this.closeImageModal());
    }
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        this.closeImageModal();
      });
    }

    this.onKeyDown = (e) => {
      if (e.key === 'Escape') this.closeImageModal();
    };
  }

  openImageModal(clickedBtn) {
    if (!this.modal || !this.modalImg) return;
    const src = clickedBtn.getAttribute('data-zoom-src');
    if (!src) return;

    this.modalImg.src = src;
    this.modal.hidden = false;
    document.body.classList.add('dl-social-image-slideshow-y--modal-open');
    window.addEventListener('keydown', this.onKeyDown);
  }

  closeImageModal() {
    if (!this.modal || !this.modalImg) return;
    this.modal.hidden = true;
    this.modalImg.removeAttribute('src');
    document.body.classList.remove('dl-social-image-slideshow-y--modal-open');
    window.removeEventListener('keydown', this.onKeyDown);
  }

  disconnectedCallback() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }

    window.removeEventListener('keydown', this.onKeyDown);
  }
}

if (!customElements.get('dl-social-image-slideshow-y')) {
  customElements.define('dl-social-image-slideshow-y', DlSocialImageSlideshowY);
}

